import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

import tr from "./locales/tr.json";
import en from "./locales/en.json";
import ar from "./locales/ar.json";
import de from "./locales/de.json";
import ru from "./locales/ru.json";

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      tr: { translation: tr },
      en: { translation: en },
      ar: { translation: ar },
      de: { translation: de },
      ru: { translation: ru },
    },
    fallbackLng: "tr",
    interpolation: {
      escapeValue: false,
    },
    detection: {
      order: ["localStorage", "navigator"],
      caches: ["localStorage"],
      lookupLocalStorage: "i18nextLng",
    },
  });

export const LANGUAGES = [
  { code: "tr", name: "Turkce", flag: "TR" },
  { code: "en", name: "English", flag: "EN" },
  { code: "ar", name: "العربية", flag: "AR", dir: "rtl" },
  { code: "de", name: "Deutsch", flag: "DE" },
  { code: "ru", name: "Русский", flag: "RU" },
];

export default i18n;
